/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendCapexDto } from '../../models/backend-capex-dto';

export interface EconomicIndicatorsCapexsRetrieve$Params {
  /**
   * A unique integer value identifying this capex.
   */
  id: number;
}

export function economicIndicatorsCapexsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: EconomicIndicatorsCapexsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendCapexDto>> {
  const rb = new RequestBuilder(rootUrl, economicIndicatorsCapexsRetrieve.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendCapexDto>;
    }),
  );
}

economicIndicatorsCapexsRetrieve.PATH = '/api/economic_indicators/capexs/{id}/';
